export enum UserType {
  CUSTOMER = 'customer',
  EMPLOYEE = 'employee'
}

export enum AuthMethod {
  TRADITIONAL = 'traditional',
  MICROSOFT_SSO = 'microsoft_sso'
}

export enum EmployeeRole {
  ADMINISTRATOR = 'administrator',
  HEAD_OF = 'head_of',
  SALES = 'sales',
  READ_ONLY = 'read_only'
}

export enum Permission {
  // Administrative permissions
  MANAGE_USERS = 'manage_users',
  MANAGE_SYSTEM = 'manage_system',
  VIEW_AUDIT_LOGS = 'view_audit_logs',

  // Management permissions
  MANAGE_ORDERS = 'manage_orders',
  MANAGE_CUSTOMERS = 'manage_customers',
  VIEW_REPORTS = 'view_reports',

  // Finance permissions
  VIEW_FINANCIAL_DATA = 'view_financial_data',
  MANAGE_BILLING = 'manage_billing',
  EXPORT_FINANCIAL_REPORTS = 'export_financial_reports',

  // Support permissions
  VIEW_CUSTOMER_DATA = 'view_customer_data',
  MANAGE_SUPPORT_TICKETS = 'manage_support_tickets',

  // Basic permissions
  VIEW_DASHBOARD = 'view_dashboard',
  VIEW_OWN_PROFILE = 'view_own_profile'
}

export interface AuthUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  userType: UserType;
  authMethod: AuthMethod;
  isActive: boolean;
  roles?: string[];
  groups?: string[];
  permissions?: string[];
  /** For customers: the company short name from the Reflex system */
  companyShortName?: string;
}

export interface AuthResponse {
  userName: string;
  token: string;
  refreshToken: string;
  userType: UserType;
  authMethod: AuthMethod;
  user?: AuthUser;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AppRegistration {
  clientId: string;
  scope: string;
}
